import { useEffect } from 'react';

const useBodyLock = (isOpen: boolean, setIsOpen: (isOpen: boolean) => void) => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPaddingRight = document.body.style.paddingRight;

    if (isOpen) {
      const scrollBarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollBarWidth}px`;

      // Add keydown event listener for ESC
      const handleEsc = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
          // Restore styles when ESC is pressed
          document.body.style.overflow = originalOverflow;
          document.body.style.paddingRight = originalPaddingRight;
          setIsOpen(false);
        }
      };

      window.addEventListener('keydown', handleEsc);

      // Cleanup event listener
      return () => {
        window.removeEventListener('keydown', handleEsc);
        document.body.style.overflow = originalOverflow;
        document.body.style.paddingRight = originalPaddingRight;
      };
    }

    // Cleanup if isOpen is false
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.paddingRight = originalPaddingRight;
    };
  }, [isOpen, setIsOpen]);
};

export default useBodyLock;
